import _axios from 'axios';
import moment from 'moment-timezone';
import { msalAuthService } from './msalAuthService';
import secureStorage from './secureStorage';

const chargingAccessToken = secureStorage.getItem('chargingAccessToken');

class ChargingHttpHandler {
  constructor(checkToken = true) {
    this.checkToken = checkToken;
    this.baseURL = process.env.REACT_APP_CHARGE_API_QUERY_URL;
    //this.baseURL = 'https://hlcchargingservice.hotaileasing.com.tw';
    
    //this.baseURL = 'https://hlcchargingservice.hotaileasing.com.tw';

    //process.env.REACT_APP_CHARGE_API_QUERY_URL || 'https://hlcchargingservice.irentcar.com.tw';
    // console.log('ChargingHttpHandler baseURL:', this.baseURL);
  }

  axios = () => {
    const instance = _axios.create({
      baseURL: this.baseURL,
      timeout: 5000000,
    });
    return instance;
  };

  async getHeader(content_type = 'application/json') {
    let headers;

    if (content_type !== '') {
      headers = { 'Content-Type': content_type };
    } else {
      headers = {};
    }

    if (!this.checkToken) {
      return headers;
    }

    // 取得 account
    const account = msalAuthService.getAccount();
    if (!account) {
      msalAuthService.login();
    }

    let accessToken = null;

    try {
      accessToken = await msalAuthService.getAccessToken();
    } catch (error) {
      console.error('取得 token 失敗', error);
      msalAuthService.login();
    }

    if (!accessToken) {
      return null;
    }

    headers.authorization = 'Bearer ' + accessToken;
    return headers;
  }

  async post(url, data = {}, content_type = 'application/json') {
    try {
      const headers = await this.getHeader(content_type);
      if (headers === null) {
        return { success: false, message: '登入逾時' };
      }

      // console.log('Request URL:', this.baseURL + url);
      // console.log('Request Data:', data);
      // console.log('Request Headers:', headers);

      const response = await this.axios().post(url, data, { headers });
      // console.log('Raw API Response:', response);

      if (response.data) {
        return {
          success: true,
          data: response.data,
        };
      } else {
        return {
          success: false,
          message: 'Invalid response format',
          details: response,
        };
      }
    } catch (error) {
      console.error('API Error:', error);
      if (error.message === 'Network Error') {
        return { success: false, message: '連線錯誤.' };
      }
      if (error.response?.status === 401) {
        return { success: false, message: '請重新登入！' };
      } else if (error.response?.status === 422) {
        console.error('422 Error Details:', error.response.data);
        return {
          success: false,
          message: '後端API資料驗證失敗, 請確認.',
          details: error.response.data,
        };
      } else {
        return {
          success: false,
          message: 'http handler error',
          details: error.response?.data || error.message,
        };
      }
    }
  }

  // 下載資料專用
  async fileDownload(url, fileExtension, fileName = 'output', headers) {
    // token 過期
    if (headers === null) {
      return { success: false, message: '登入逾時' };
    }

    return this.axios()
      .get(url, { headers: headers, responseType: 'blob' })
      .then((response) => {
        if (response.status === 200) {
          const blob = new Blob([response.data], {
            type: 'text/csv;charset=utf-8;',
          });
          const downloadUrl = window.URL.createObjectURL(blob); // create url from blob
          const fileLink = document.createElement('a'); // create link for file
          fileLink.href = downloadUrl;
          fileLink.download = fileName + '.' + fileExtension; // download filename
          document.body.appendChild(fileLink); // append file link to download
          fileLink.click();
          fileLink.remove(); // remove file link after click
          return { success: true };
        } else {
          return { success: false, message: 'http handler error' };
        }
      })
      .catch((error) => {
        console.error('API Error:', error);
        if (error.message === 'Network Error') {
          return { success: false, message: '連線錯誤.' };
        }
        if (error.response?.status === 401) {
          return { success: false, message: '請重新登入！' };
        } else if (error.response?.status === 422) {
          console.error('422 Error Details:', error.response.data);
          return {
            success: false,
            message: '後端API資料驗證失敗, 請確認.',
            details: error.response.data,
          };
        } else {
          return {
            success: false,
            message: 'http handler error',
            details: error.response?.data || error.message,
          };
        }
      });
  }
}

export default ChargingHttpHandler;
